<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div slot="header">
          <h5 class="title">{{ $t('common_words.board_select_info') }}</h5>
        </div>
        <div class="d-flex justify-content-center my-5">
          <el-transfer
            v-model="value"
            :data="data"
            :titles="[$t('widgets.my_widgets'), $t('common_words.my_board')]"
            :filter-method="filterMethod"
            :button-texts="[$t('common_words.remove'), $t('common_words.add')]"
            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
            @change="handleChange"
            target-order="push"
            filterable
            :filter-placeholder="$t('common_words.indicator_name')"
          >
          </el-transfer>
        </div>
        <div class="text-right mb-5">
          <button
            :disabled="changed"
            @click="validate"
            class="btn custom-btn-success custom-shadow-btn"
            style="background-color: #42a94c !important"
          >
            {{ $t('common_words.confirm') }}
          </button>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Transfer } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMenu from 'src/util/mixinMenu';
import MixinTranslate from 'src/util/mixinTranslate';
import i18n from 'src/i18n';

export default {
  components: {
    [Transfer.name]: Transfer,
  },
  data() {
    return {
      widgets: [],
      userWidgets: [],
      widgetsNames: [],
      userWidgetsNames: [],
      widgetsIds: [],
      userWidgetsIds: [],
      data: [],
      value: [],
      changed: true,
    };
  },
  mixins: [mixinMasters, MixinPermissions, MixinMenu, MixinTranslate],
  watch: {
    '$i18n.locale': 'generateData',
  },
  methods: {
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },
    handleChange(value, direction, movedKeys) {
      this.changed = false;
    },

    generateData() {
      const data = [];
      this.widgets.forEach((widget, index) => {
        data.push({
          label: this.translateDataBaseText(widget.name, widget.other_values),
          key: index,
          initial: this.widgetsIds[index],
        });
      });
      this.data = data;
      if (this.userWidgets && this.userWidgets.length > 0) {
        this.userWidgets.forEach((userWidget, index) => {
          const findedIndex = this.widgets.findIndex(
            (widget) => userWidget.id === widget.id
          );
          this.value.push(findedIndex);
        });
      }
      this.showHideLoading();
    },
    validate() {
      if (this.value && this.value.length > 0) {
        if (this.value.length <= 4) {
          const msg = i18n.t('message.widget.update_indicators');
          const html = i18n.t('message.widget.validate_update');
          SweetAlert.confirm(msg, html).then((result) => {
            if (result.value) {
              this.assingWidgets();
            }
          });
        } else {
          SweetAlert.warning(i18n.t('sweet_alert.widget.indicator_warning'));
        }
      } else {
        SweetAlert.warning(i18n.t('sweet_alert.widget.indicator_alert'));
      }
    },
    assingWidgets() {
      const widgetUserIds = this.value.map((val) => this.widgetsIds[val]);
      const requestData = {
        route: 'widgets/assignuser',
        widgetsIds: widgetUserIds,
      };
      this.showHideLoading(true);
      Axios.saveMaster(requestData)
        .then((response) => {
          this.changed = true;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('widgets/user')
        .then((response1) => {
          Axios.getMasters('widgets/indexbyuser')
            .then((response2) => {
              this.widgets = response1.data.data;
              this.widgetsNames = this.widgets.map((widget) => widget.name);
              this.widgetsIds = this.widgets.map((widget) => widget.id);
              this.userWidgets = response2.data.data;
              this.userWidgetsNames = this.userWidgets.map(
                (userWidget) => userWidget.name
              );
              this.userWidgetsIds = this.userWidgets.map(
                (userWidget) => userWidget.id
              );
              this.generateData();
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
};
</script>
<style>
.el-transfer-panel {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 400px;
  max-height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.el-transfer-panel .el-transfer-panel__header {
  height: 40px;
  line-height: 40px;
  background: #42a94c;
  margin: 0;
  padding-left: 15px;
  border-bottom: 1px solid #39653b;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #000;
}
.el-transfer__button.is-disabled,
.el-transfer__button.is-disabled:hover {
  border: 1px solid #39653b;
  background-color: #39653b;
  opacity: 0.5;
  filter: alpha(opacity=50);
  color: #c0c4cc;
}
.el-transfer__button {
  display: block;
  margin: 0 auto;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  background-color: #42a94c;
  border-color: #42a94c;
  font-size: 0;
  width: 100px;
}
.el-transfer__button:hover {
  background-color: #42a94c;
}
.el-transfer-panel__filter .el-input__inner {
  height: 32px;
  width: 100%;
  font-size: 12px;
  display: inline-block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 0px;
  padding-right: 10px;
  padding-left: 30px;
}
.el-input__inner:hover {
  border-color: #42a94c;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #42a94c;
  outline: 0;
}
.el-transfer-panel
  .el-transfer-panel__header
  .el-checkbox
  .el-checkbox__label
  span {
  position: absolute;
  right: 15px;
  color: #464646;
  font-size: 12px;
  font-weight: 400;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #42a94c;
  border-color: #42a94c;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #42a94c;
}
.el-checkbox__inner:hover {
  border-color: #42a94c;
}
.el-transfer-panel__item:hover {
  color: #42a94c;
}
</style>
